<div class="audience-users-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="audience && audience.parent; else defaultAudienceTitle">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </div>
            <ng-template #defaultAudienceTitle>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name" *ngIf="audience">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </ng-template>
        </div>
    </mat-toolbar>
    <div class="audience-users">
        <ng-container *ngIf="isAutomaticAudienceFlag; else manualAudienceMembers">
            <div *ngIf="filtersLoading" class="white" fxLayout="column" fxLayoutAlign="center center">
                <div class="shimmer-container min-w-full p-0">
                    <div class="shimmer p-12">
                        <div class="shimmer-card !max-w-full table h-480 animate"></div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="!filtersLoading && !hasAudienceFilters">
                <div class="automatic-audience-empty-state empty-state-container-modern my-0 mx-auto" fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon class="participant-view-illustration" svgIcon="no_members_filter"></mat-icon>
                    <h3>{{ 'ENGAGE.AUDIENCE.LABELS.MEMBERS.EMPTY_FILTERS.TITLE' | translate }}</h3>
                    <p>{{ 'ENGAGE.AUDIENCE.LABELS.MEMBERS.EMPTY_FILTERS.DESCRIPTION' | translate }}</p>
                    <app-flat-button [label]="'ENGAGE.AUDIENCE.BUTTONS.ADD_FILTER'" [icon]="'add'" (onClick)="openFilterDialog()"></app-flat-button>
                </div>
            </ng-container>

            <ng-container *ngIf="!filtersLoading && hasAudienceFilters">
                <div class="automatic-audience-content">
                <div class="automatic-audience-filters-summary">
                    <div class="automatic-audience-filters-summary__groups">
                        <div
                            class="automatic-audience-filters-summary__row"
                            *ngFor="let group of audienceFilterGroups; trackBy: trackAudienceFilterGroup"
                        >
                            <span class="automatic-audience-filters-summary__label">{{ group.categoryLabel }} ({{ group.chips.length }}):</span>
                            <span class="automatic-audience-filters-summary__values">
                                <ng-container *ngFor="let chip of group.chips; let last = last">
                                    <span
                                        class="automatic-audience-filters-summary__value"
                                        [class.automatic-audience-filters-summary__value--invalid]="chip.isInvalid"
                                    >
                                        <span class="automatic-audience-filters-summary__value-label">{{ chip.chipLabel }}</span>
                                        <mat-icon
                                            *ngIf="chip.isInvalid"
                                            class="automatic-audience-filters-summary__warning"
                                            color="warn"
                                            matTooltip="{{ 'ENGAGE.AUDIENCE.TOOLTIPS.BROKEN_AUDIENCE_FILTER' | translate }}"
                                        >
                                            warning
                                        </mat-icon>
                                    </span><span *ngIf="!last">, </span>
                                </ng-container>
                            </span>
                        </div>
                    </div>
                    <button type="button" class="automatic-audience-filters-summary__change" (click)="openFilterDialog()">
                        <span class="text-primary-500 automatic-audience-filters-summary__change-label">{{ 'ENGAGE.AUDIENCE.BUTTONS.CHANGE_FILTER' | translate }}</span>
                        <mat-icon class="text-primary-500 automatic-audience-filters-summary__change-icon">keyboard_arrow_right</mat-icon>
                    </button>
                </div>

                <div class="automatic-audience-members-panel">
                    <app-automatic-audience-members-list
                        [audienceId]="audienceId"
                        [audienceName]="audience?.name"
                        [reloadToken]="membersReloadToken"
                    ></app-automatic-audience-members-list>
                </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #manualAudienceMembers>
        <mat-toolbar-row class="audience-users-toolbar pb-12" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayoutAlign="space-between center" fxLayoutAlign.gt-xs="end center">
                <app-search-outline [searchInput]="rootSearchInput" *ngIf="isRootAudience"></app-search-outline>
                <app-search-outline [searchInput]="searchInput" *ngIf="!isRootAudience"></app-search-outline>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center">
                <app-white-button
                    class="mr-16"
                    *ngIf="audience && audience.parent"
                    [icon]="'add'"
                    [label]="'ENGAGE.BUTTONS.ADD_USERS'"
                    (onClick)="openDialogAddUsers()"
                    [showThreeDots]="true"
                ></app-white-button>

                <app-white-button
                    *ngIf="audience && ((isRootAudience && (selectedRootUserIds$ | async)?.length) || (!isRootAudience && (selectedUserIds$ | async)?.length))"
                    class="mr-8"
                    [icon]="'drive_file_move'"
                    [label]="'GENERAL.BUTTON.MOVE_TO'"
                    (onClick)="openDialogMoveUsers()"
                    [showThreeDots]="true"
                ></app-white-button>

                <ng-container *ngIf="actionPermissions?.canShowActionsMenu">
                    <button
                        mat-raised-button
                        color="accent"
                        class="mat-elevation-z0"
                        fxLayout="row"
                        [matMenuTriggerFor]="membersActionsMenu"
                        [disabled]="!actionsUserCount"
                        aria-label="More"
                    >
                        <span>
                            {{ actionsUserCount || 0 }}
                            {{ 'GENERAL.LABEL.USER' | translate: { total: actionsUserCount } }}
                        </span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #membersActionsMenu="matMenu" xPosition="before" class="users-actions-menu-panel">
                        <button mat-menu-item (click)="downloadUsers()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canDownload">
                            <mat-icon class="mr-8">cloud_download</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.DOWNLOAD_XLSX' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            (click)="openPasswordlessAccessDialog()"
                            [disabled]="!actionsUserCount"
                            *ngIf="actionPermissions.canCreatePasswordless && actionPermissions.isPasswordlessLoginFeatureEnabled"
                        >
                            <mat-icon svgIcon="qr_code" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="openAssignUserToTeamDialog()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canAssignTeam">
                            <mat-icon svgIcon="team" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUsersToExperience()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canAssignExperience">
                            <mat-icon svgIcon="assign_user_to_experience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUsersToAudience()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canAssignAudience">
                            <mat-icon svgIcon="assign_user_to_audience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUsersToCourse()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canAssignCourse">
                            <mat-icon class="mr-8">school</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.TAKE_OVER' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            (click)="resetPasswords()"
                            [disabled]="!actionsUserCount"
                            *ngIf="actionPermissions.canResetPassword && !actionPermissions.isSSOFeatureEnabled"
                        >
                            <mat-icon svgIcon="lock_reset" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: actionsUserCount } }}</span>
                        </button>

                        <button mat-menu-item (click)="removeMembersViaActions()" [disabled]="!actionsUserCount" *ngIf="actionPermissions.canRemove">
                            <mat-icon class="mr-8">delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </ng-container>
            </div>
        </mat-toolbar-row>
        <div *ngIf="audience && !isRootAudience" class="mb-32 content white">
            <app-audience-users-list
                [audienceName]="audience && audience.name"
                [audienceId]="audienceId"
                [sortBy]="sortBy"
                [sortOrder]="sortOrder"
                [loadUser$]="loadUser$"
                [user$]="users$"
                [filteredUsers$]="filteredAudienceUsers$"
                [selectedUserId$]="selectedUserIds$"
                [searchTerm$]="searchTerm$"
                (select)="selectUser($event)"
                (toggle)="masterToggle($event)"
                [totalCount$]="totalCount$"
            >
            </app-audience-users-list>
        </div>

        <div *ngIf="audience && isRootAudience" class="mb-32 content white">
            <app-root-audience-users-list
                [audienceName]="audience && audience.name"
                [audienceId]="audienceId"
                [sortBy]="sortBy"
                [sortOrder]="sortOrder"
                [loadUser$]="loadUser$"
                [user$]="rootUsers$"
                [filteredUsers$]="filteredRootAudienceUsers$"
                [selectedRootUserIds$]="selectedRootUserIds$"
                [searchTerm$]="rootSearchTerm$"
                (select)="selectUser($event)"
                (toggle)="masterToggle($event)"
                [totalCount$]="rootTotalCount$"
            >
            </app-root-audience-users-list>
        </div>

        <ng-template #spinner>
            <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
                <div class="p-24">
                    <mat-spinner></mat-spinner>
                </div>
            </div>
        </ng-template>
        </ng-template>
    </div>
</div>
